import { ChangeEvent, FC, useEffect, useState } from 'react';
import { InputText } from '../Input/styles';

interface InputNumberProps {
	onChange: (value: string) => void;
	defaultValue?: string;
}

export const InputNumber: FC<InputNumberProps> = ({
	onChange,
	defaultValue = '',
}) => {
	const [value, setValue] = useState(defaultValue);

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const inputValue = event.target.value.replace(/[^\d]/, '');
		let newValue = Math.max(1, Number(inputValue)).toString();
		if (inputValue === '') {
			newValue = '';
		}
		onChange(newValue);
		setValue(newValue);
	};

	useEffect(() => {
		setValue(defaultValue);
	}, [defaultValue]);

	return (
		<InputText
			type="text"
			min="1"
			onChange={handleChange}
			value={value}
			$textIndent="15px"
		/>
	);
};
